import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { statCardSurface } from "@/components/common/statCardSurface";

/**
 * Icon + label + (non-numeric) value card. Shared replacement for the identical
 * inline InfoCards on the company / location detail pages.
 */
export interface InfoCardProps {
  icon: ReactNode;
  label: string;
  value: ReactNode;
  className?: string;
}

export function InfoCard({ icon, label, value, className }: InfoCardProps) {
  return (
    <div
      className={cn(
        statCardSurface,
        "flex-1 p-4",
        className,
      )}
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <div className="flex size-8 shrink-0 items-center justify-center rounded-md bg-(--color-surface-muted)">
            {icon}
          </div>
          <span className="text-sm font-medium text-(--color-text-secondary)">
            {label}
          </span>
        </div>
        <span className="text-base font-medium text-(--color-text-primary)">
          {value}
        </span>
      </div>
    </div>
  );
}
